const registry = new Map();
export function registerNestedOrbParser(key, parser) {
    if (registry.has(key)) {
        console.warn(`[NestedOrbExpansion] Overwriting parser for key "${key}"`);
    }
    registry.set(key, parser);
}
export function getNestedOrbParser(key) {
    return registry.get(key);
}
export function clearNestedOrbParsers() {
    registry.clear();
}
